import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { t } from '../locales/translate.js';

function Element({ apiCall, user, selectedDepot, setSelectedDepot }) {


    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [depots, setDepots] = useState([]);
    const [date, setDate] = useState(new Date());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());

    useEffect(() => {
        console.log("Selected Depot changed:", selectedDepot);
        // Fetch reports data when the component mounts
        error && setError(null); // Reset error state
        let data = {};
        if (selectedDepot && selectedDepot !== "all") {
            data.depot = selectedDepot;
        }

        setDate(new Date(year, month));

        refreshDocuments(new Date(year, month))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall, selectedDepot, month, year]);

    const refreshDocuments = (date ) => {
        
        

        let formattedDate = date.toISOString().split("T")[0];
        console.log(formattedDate);
        apiCall("GET", "transport-documents", { date: formattedDate })
            .then(({ response, error }) => {
                if (error) {
                    console.error("Error fetching documents:", error);
                    setError(error);
                } else {
                    console.log("Fetched documents:", response);
                    setDepots(response || []);
                }
            });
    };

    // Render the list of reports
    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5>{t('Transport_documents')} </h5>
            </div>

            <div className="calendar-wrapper">
                <ul className="year">
                    {Array.from({ length: 4 }, (_, i) => {
                        const yearLi = new Date().getFullYear()-3 + i;
                        return (
                            <li key={yearLi} className={yearLi === year ? "active" : ""} onClick={() => setYear(yearLi)}>
                                {yearLi}
                            </li>
                        );
                    })}
                    </ul>

                <ul className="month">
                    <li className={month === 1 ? "active" : ""} onClick={() => setMonth(1)}>{t('january')}</li>
                    <li className={month === 2 ? "active" : ""} onClick={() => setMonth(2)}>{t('february')}</li>
                    <li className={month === 3 ? "active" : ""} onClick={() => setMonth(3)}>{t('march')}</li>
                    <li className={month === 4 ? "active" : ""} onClick={() => setMonth(4)}>{t('april')}</li>
                    <li className={month === 5 ? "active" : ""} onClick={() => setMonth(5)}>{t('may')}</li>
                    <li className={month === 6 ? "active" : ""} onClick={() => setMonth(6)}>{t('june')}</li>
                    <li className={month === 7 ? "active" : ""} onClick={() => setMonth(7)}>{t('july')}</li>
                    <li className={month === 8 ? "active" : ""} onClick={() => setMonth(8)}>{t('august')}</li>
                    <li className={month === 9 ? "active" : ""} onClick={() => setMonth(9)}>{t('september')}</li>
                    <li className={month === 10 ? "active" : ""} onClick={() => setMonth(10)}>{t('october')}</li>
                    <li className={month === 11 ? "active" : ""} onClick={() => setMonth(11)}>{t('november')}</li>
                    <li className={month === 12 ? "active" : ""} onClick={() => setMonth(12)}>{t('december')}</li>
                </ul>
            </div>

            <div className="card-body projects-wrapper" >
                <div className="row g-4">

                    {success && (
                        <div className="col-12">
                            <div className="alert alert-success">
                                {success}
                            </div>
                        </div>
                    )}

                    {error && (
                        <div className="col-12">
                            <div className="alert alert-danger">
                                {error}
                            </div>
                        </div>
                    )}

                    {!depots.length && user?.id && (
                        <div className="col-12">
                            {t('no_documents_available')}
                        </div>
                    )}
                    {depots?.length > 0 && (
                        <div className="container-fluid user-list-wrapper transport-wrapper">
                            <div className="row">
                                <div className="col-12">
                                    <div className="list-product user-list-table">
                                        <div className="table-responsive custom-scrollbar">
                                            <div id="roles-permission_wrapper" className="dt-container dt-empty-footer"><div className="dt-layout-row"><div className="dt-layout-cell dt-start "><div className="dt-length">
                                                <label htmlFor="dt-length-0">{t('entries_per_page')}</label></div></div><div className="dt-layout-cell dt-end "></div></div><div className="dt-layout-row dt-layout-table"><div className="dt-layout-cell "><table className="table dataTable" id="roles-permission" aria-describedby="roles-permission_info"><colgroup><col /><col /><col /><col /><col /><col /><col /></colgroup>
                                                    <thead>
                                                        <tr role="row">
                                                            <th data-dt-column="1" rowspan="1" colspan="1" className="dt-orderable-asc dt-orderable-desc dt-ordering-asc" aria-sort="ascending" tabindex="0">
                                                                <span className="dt-column-title" role="button">
                                                                    <span className="c-o-light f-w-600">{t('date')}</span>
                                                                </span>
                                                            </th>
            
                                                            <th data-dt-column="3" rowspan="1" colspan="1" className="dt-orderable-asc dt-orderable-desc" tabindex="0"><span className="dt-column-title" role="button">
                                                                <span className="c-o-light f-w-600">{t('depot_name')}</span></span>
                                                            </th>
                                                            <th data-dt-column="4" rowspan="1" colspan="1" className="dt-orderable-asc dt-orderable-desc" tabindex="0"><span className="dt-column-title" role="button">
                                                                <span className="c-o-light f-w-600">{t('document')}</span></span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {depots?.length > 0 && depots?.map((report, index) => (
                                                            <tr className="product-removes inbox-data" key={index} role="row" data-id={report.id}>
                                                                <td className="sorting_1 organs_col">
                                                                    <span className="c-o-dark f-w-600">{report.date}</span>
                                                                </td>
                                                                <td>
                                                                    {report.depotName}
                                                                </td>

                                                                <td>
                                                                    <a href={`${process.env.REACT_APP_API_HOST}/storage/${report.filename}`}>
                                                                        <svg className="pdf" fill="#000000" width="800px" height="800px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
                                                                            <g fill-rule="evenodd">
                                                                                <path d="M1185.46.034V564.74h564.705v1355.294H168.99V.034h1016.47ZM900.508 677.68c-16.829 0-31.963 7.567-42.918 21.007-49.807 59.972-31.398 193.016-18.748 272.075 2.823 17.958.452 36.141-7.228 52.518l-107.86 233.223c-7.905 16.942-20.555 30.608-36.592 39.53-68.104 37.835-182.287 89.675-196.066 182.626-4.97 30.268 5.082 56.357 28.574 79.85 15.925 15.133 35.238 22.7 56.245 22.7 81.43 0 132.819-71.717 188.273-148.517 24.62-34.221 61.666-55.229 102.437-60.876 76.349-10.503 167.83-32.527 223.172-46.983 27.897-7.341 56.358-5.534 83.802 3.162 48.565 15.586 66.975 25.073 122.768 25.073 50.371 0 84.818-11.746 101.534-34.447 13.44-16.828 16.715-39.53 10.164-65.619-11.858-42.804-2.033-89.675-133.044-89.675-29.365 0-57.94 2.824-81.77 6.099-36.819 4.97-73.299-10.955-97.016-40.885-32.301-40.546-65.167-88.433-87.981-123.219-16.151-24.508-21.572-53.986-16.264-83.124 15.473-84.706 18.41-147.615-23.492-206.683-17.619-25.186-41.223-37.835-67.99-37.835Zm397.903-660.808 434.936 434.937h-434.936V16.873Z" />
                                                                                <path d="M791.057 1297.943c92.273-43.37 275.916-65.28 275.916-65.28-92.386-88.998-145.92-215.04-145.92-215.04-43.257 126.607-119.718 264.282-129.996 280.32" />
                                                                            </g>
                                                                        </svg>
                                                                    </a>
                                                                </td>

                                                            </tr>))}
                                                    </tbody>
                                                    <tfoot></tfoot></table></div></div>
                                                <div className="dt-layout-row"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>)}


                </div>

            </div>
        </div>

    );
}

export default Element;
